module.exports = __webpack_public_path__ + "static/media/HL5.7694b40f.jpg";